<template>

  <select-dropdown :ref="_uid" :showValueId="true" @onChange="onChange" />
  
</template>

<script>

  import SelectDropdown from "./select-dropdown.vue"
  import bankList from "@/utils/banks"

  export default {

    name: "SelectBank",

    props: {
      uppercase: { type: Boolean, default: true },
    },
    
    components: {
      SelectDropdown,
    },

    mounted() {

      let banks = bankList.slice()

      if (this.uppercase)
        banks.map((bank) => bank.value = bank.value.toUpperCase())

      this.$refs[this._uid].setValues(banks)
    },

    methods: {

      setSelected(bank) {      
        this.$refs[this._uid].setSelected(bank)
      },

      onChange(bank) {
        this.$emit("onChange", bank)
      },

      clear() {
        this.$refs[this._uid].clear()
      },

      reset() {
        this.$refs[this._uid].reset()
      },
    },
  }

</script>

